const initialState = {
  results: null,
  pagination: null
}

export default function main(state = initialState, action) {
  switch (action.type) {
  case 'SET_STATE_REVIEWS':
    return Object.assign({}, state, action.params)
  case 'SET_STATE_REVIEW':
    // レビュー更新API実行時に、一覧の中に一致するレビューがあったらメモリ上でも更新
    // (画面への反映を速くするため)
    const review = state.results && state.results.find(r => r.id == action.params.id)
    if (review) { Object.assign(review, action.params) }
    return state
  case 'RESET_STATE_REVIEWS':
    return initialState
  default:
    return state
  }
}
